import { render } from "./AddressOperation.vue?vue&type=template&id=6960c744"
import script from "./AddressOperation.vue?vue&type=script&lang=js"
export * from "./AddressOperation.vue?vue&type=script&lang=js"

import "./AddressOperation.vue?vue&type=style&index=0&id=6960c744&lang=scss"

import exportComponent from "/Users/a/Desktop/app/pulizhenkong_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__